import SystemMenu from './menu'
export default SystemMenu
